import { Image } from '@chakra-ui/react';
import React from 'react';

import { WLSimpleHeader } from '../../design-library';
import HeaderImage from './assets/lcb-tower-symbol-header.png';

interface LifeCareerBalanceHeaderAdapterProps {
  isApplyNow: boolean;
}

const LifeCareerBalanceHeaderAdapter: React.FC<
  LifeCareerBalanceHeaderAdapterProps
> = ({ isApplyNow }) => {
  let slug = '/lifecareerbalance/applynow/';

  return (
    <WLSimpleHeader
      sticky={false}
      image={{
        image: <Image src={HeaderImage as string} />,
        href: '/lifecareerbalance/',
      }}
      action={{
        color: 'blue',
        label: 'Start Your Career',
        href: isApplyNow ? '#form' : slug,
      }}
    />
  );
};

export default LifeCareerBalanceHeaderAdapter;
